export function stringifyNavigationPath(path) {
    var _a;
    return (_a = path === null || path === void 0 ? void 0 : path.join(' ')) !== null && _a !== void 0 ? _a : '';
}
